"use strict";

/* todo: I want this to actually be an array of Function | string but that causes errors */
if (typeof exports !== "undefined") Object.defineProperty(exports, "babelPluginFlowReactPropTypes_proptype_StyleSheet", {
  value: require("prop-types").shape({
    create: require("prop-types").func.isRequired
  })
});

/* eslint-disable no-undef */


//////////////////
// WEBPACK FOOTER
// ./~/styled-components/lib/types.js
// module id = 2
// module chunks = 35783957827783 114276838955818 253011397747672